import { render, staticRenderFns } from "./PricingAll.vue?vue&type=template&id=1dc1a6c1"
import script from "./PricingAll.vue?vue&type=script&lang=js"
export * from "./PricingAll.vue?vue&type=script&lang=js"
import style0 from "./PricingAll.vue?vue&type=style&index=0&id=1dc1a6c1&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports